export default __webpack_public_path__ + "static/media/evenShotBg.e157da88.png";